import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface Props{
  Component:any
}

const Page404: React.FC<Props> = ({ Component }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/404");
  }, []);

  useEffect(() => {
    navigate("/404");
  }, [navigate]);

  return (
    <div>
      <Component />
    </div>
  );
};

export default Page404;
